import * as React from 'react';
import MediaQuery from 'react-responsive';
import Dialog from '@mui/material/Dialog';
import * as DialogStyles from './DialogAdapter.css';

import { MOBILE_MIN_WIDTH, TABLET_MIN_WIDTH } from '../../../utils';
import Dropdown from '../../../Dropdown';
import ModalTransitionComponent from '../../../ModalTransitionComponent';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	outsideClickIgnoreClass?: string;
	popupClassName?: string;
}

export const DialogAdapter: React.FunctionComponent<Props> = props => {
	return (
		<>
			<MediaQuery minWidth={+TABLET_MIN_WIDTH + 1}>
				<Dropdown
					onClose={props.onClose}
					isOpen={props.isOpen}
					outsideClickIgnoreClass={props.outsideClickIgnoreClass}
				>
					{props.children}
				</Dropdown>
			</MediaQuery>

			<MediaQuery maxWidth={TABLET_MIN_WIDTH} minWidth={MOBILE_MIN_WIDTH}>
				<Dialog
					onClose={props.onClose}
					open={props.isOpen}
					classes={{
						root: props.popupClassName,
						paper: DialogStyles.dialog__paper
					}}
				>
					{props.children}
				</Dialog>
			</MediaQuery>

			<MediaQuery maxWidth={MOBILE_MIN_WIDTH}>
				<Dialog
					TransitionComponent={ModalTransitionComponent}
					onClose={props.onClose}
					open={props.isOpen}
					fullScreen={true}
					classes={{
						root: props.popupClassName
					}}
				>
					{props.children}
				</Dialog>
			</MediaQuery>
		</>
	);
};
